import { FETCH_DISTRIBUTOR, FETCH_DISTRIBUTOR_FULFILLED, FETCH_DISTRIBUTOR_REJECTED } from '../actions'

export default (state = {
  data: null,
  fetching: false,
  fetched: false,
  error: null
}, action) => {
  switch (action.type) {
    case FETCH_DISTRIBUTOR:
      return { ...state, fetching: true, fetched: false, error: null }
    case FETCH_DISTRIBUTOR_FULFILLED:
      const payload = action.payload
      return { ...state, fetching: false, fetched: true, error: null, data: payload }
    case FETCH_DISTRIBUTOR_REJECTED:
      return { ...state, fetching: false, fetched: false, error: action.payload, data: null }

    default:
      return state
  }
}
